import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug, faMagicWandSparkles, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../constants/theme';

const Section = styled.section`
  padding: 6rem 2rem;
  background: rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, ${COLORS.pink}, ${COLORS.purple}, ${COLORS.cyan});
    opacity: 0.2;
    transform: translateY(-50%);
  }
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  text-align: center;
  margin-bottom: 3rem;
  color: ${COLORS.pink};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const StepCard = styled(motion.div)`
  text-align: center;
  position: relative;
  .step-number {
    width: 40px;
    height: 40px;
    background: ${COLORS.gradientPrimary};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin: 0 auto 1rem;
  }
  h3 { color: ${COLORS.cyan}; margin-bottom: 1rem; }
  p { color: ${COLORS.whiteTransparent}; line-height: 1.6; }
`;

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    { num: 1, icon: faPlug, titleKey: 'landing.step1Title', descKey: 'landing.step1Desc', delay: 0 },
    { num: 2, icon: faMagicWandSparkles, titleKey: 'landing.step2Title', descKey: 'landing.step2Desc', delay: 0.2 },
    { num: 3, icon: faFileAlt, titleKey: 'landing.step3Title', descKey: 'landing.step3Desc', delay: 0.4 }
  ];

  return (
    <Section id="how-it-works">
      <Title>{t('landing.howItWorksTitle')}</Title>
      <Grid>
        {steps.map((step) => (
          <StepCard key={step.num} {...fadeUp} transition={{ duration: 0.5, delay: step.delay }}>
            <div className="step-number">{step.num}</div>
            <h3><FontAwesomeIcon icon={step.icon} /> {t(step.titleKey)}</h3>
            <p>{t(step.descKey)}</p>
          </StepCard>
        ))}
      </Grid>
    </Section>
  );
}

export default HowItWorksSection;
